<section>
  <section class="table-content">

    <section class="filters">
      <input (input)="getClasses('search', searchClasses)" [(ngModel)]="searchClasses" type="search"
             name="searchClasses"
             placeholder="Search name, class teacher's name...">

      <div>
        @if (loggedUserRole === 'SUPER_ADMIN' && schools() !== null) {
          <select (change)="getClasses('school_id', filterSchoolId)" [(ngModel)]="filterSchoolId" name="schoolId"
                  id="schoolId">
            <option value="" hidden disabled>Select a school</option>
            <option value="">All School</option>


            @for (s of schools()?.payload; track $index) {
              <option [value]="s.id">{{ Helpers.capitalizeWords(s.school_name) }}</option>
            }

          </select>
        }

        <select (change)="getClasses('academic_year_id', academicYearId)" [(ngModel)]="academicYearId"
                name="academicYearId" id="academicYearId">
          <option value="" hidden disabled>Select an academic year</option>
          <option value="">All academic years</option>

          @for (a of academicYears()?.payload; track $index) {
            <option [value]="a.id">{{ a.name }}</option>
          }
        </select>

        <select (change)="getClasses('level_id', filterSchoolId)" [(ngModel)]="filterSchoolId" name="schoolId"
                id="schoolId">
          <option value="" hidden disabled>Select a level</option>
          <option value="">All Levels</option>

          @for (s of levels()?.payload; track $index) {
            <option [value]="s.id">{{ s.name }}</option>
          }

        </select>

        <select (change)="getClasses('status', classStatus)" [(ngModel)]="classStatus" name="status" id="status">
          <option value="" hidden disabled>Select a status</option>
          <option value="">All Statuses</option>

          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
          <option value="ARCHIVED">Archived</option>
        </select>
      </div>
    </section>

    <div class="table-wrapper">
      <table>
        <thead>
        <tr>
          <th>CLASS ID</th>
          <th>CLASS NAME</th>
          <th>CLASS TEACHER</th>
          <th>ACADEMIC YEAR</th>
          <th>STATUS</th>
          <th class="options-column">ACTIONS</th>
        </tr>
        </thead>

        <tbody>
          @if (isFiltering()) {
            <td colspan="5">
              <app-loading-indicator />
            </td>
          } @else {
            @if (!classes()?.payload?.length) {
              <tr>
                <td colspan="5" class="empty">
                  <app-not-found-error>
                    NO CLASSES FOUND
                  </app-not-found-error>
                </td>
              </tr>
            } @else {
              @for (u of classes()?.payload; track u.id) {
                <tr>
                  <td>
                    {{ u.public_id }}
                  </td>

                  <td>
                    {{ u.level_name + u.name }}
                  </td>

                  <td>
                    {{ ((u?.class_teacher_first_name ?? '') + ' ' + (u?.class_teacher_last_name ?? 'None Assigned')) }}
                  </td>

                  <td class="role">
                    <p class="academic-year">{{ u.academic_year_name }}</p>
                  </td>

                  <td class="status">
                    <p [ngClass]="u.status">{{ Helpers.replaceUnderscore(u.status) }}</p>
                  </td>

                  <td class="options-column">
                    <app-action-button>
                      <button (click)="navigateToDetailPage(u.id, 'class-details')" type="button" class="menu-item">View
                        details
                      </button>
                      @if (admins.includes(loggedUserRole ?? '')) {
                        <button (click)="selectClass('status',u)" type="button" class="menu-item">Change status</button>
                      }

                    </app-action-button>
                  </td>
                </tr>
              }
            }
          }
        </tbody>
      </table>
    </div>

    <app-pagination
      [page]="classes()?.pagination?.page ?? 0"
      [size]="classes()?.pagination?.size ?? 10"
      [totalElements]="classes()?.pagination?.totalElements ?? 0"
      [totalPages]="classes()?.pagination?.totalPages ?? 0"
      [first]="classes()?.pagination?.first ?? true"
      [last]="classes()?.pagination?.last ?? false"
      [hasNext]="classes()?.pagination?.hasNext ?? false"
      [hasPrevious]="classes()?.pagination?.hasPrevious ?? false"
      (pageChange)="loadPage($event)">
    </app-pagination>

  </section>
</section>


@if (changeStatus()) {
  <section class="pop-up">
    <div class="bg" (click)="changeStatus.set(false)"></div>

    <form #changeStatusForm="ngForm" (ngSubmit)="editClassFn(changeStatusForm, 'status')">
      <div class="form-heading">
        <div class="image-box">
          <svg fill="#fff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52" enable-background="new 0 0 52 52"
               xml:space="preserve" stroke="#fff">
            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
            <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
            <g id="SVGRepo_iconCarrier">
              <path
                d="M20,37.5c0-0.8-0.7-1.5-1.5-1.5h-15C2.7,36,2,36.7,2,37.5v11C2,49.3,2.7,50,3.5,50h15c0.8,0,1.5-0.7,1.5-1.5 V37.5z">
              </path>
              <path
                d="M8.1,22H3.2c-1,0-1.5,0.9-0.9,1.4l8,8.3c0.4,0.3,1,0.3,1.4,0l8-8.3c0.6-0.6,0.1-1.4-0.9-1.4h-4.7 c0-5,4.9-10,9.9-10V6C15,6,8.1,13,8.1,22z">
              </path>
              <path
                d="M41.8,20.3c-0.4-0.3-1-0.3-1.4,0l-8,8.3c-0.6,0.6-0.1,1.4,0.9,1.4h4.8c0,6-4.1,10-10.1,10v6 c9,0,16.1-7,16.1-16H49c1,0,1.5-0.9,0.9-1.4L41.8,20.3z">
              </path>
              <path
                d="M50,3.5C50,2.7,49.3,2,48.5,2h-15C32.7,2,32,2.7,32,3.5v11c0,0.8,0.7,1.5,1.5,1.5h15c0.8,0,1.5-0.7,1.5-1.5 V3.5z">
              </path>
            </g>
          </svg>
        </div>
        <div>
          <h6>Change Status</h6>
          <small>Updating status of {{ selectedClass.level_name }}{{ selectedClass.name }}</small>
        </div>
      </div>

      <div class="form-container">
        <div class="status">
          <small>Current status:</small>
          <p [ngClass]="selectedClass.status">{{ selectedClass.status }}</p>
        </div>

        <div>
          <label for="newStatus">New Status <span class="required-check">*</span></label>
          <select required [(ngModel)]="newStatus" name="newStatus" id="newStatus">
            <option value="" hidden disabled>Select a status</option>

            @for (s of validStatuses; track $index) {
              @if (s !== selectedClass.status) {
                <option [value]="s">{{ Helpers.toSentenceCase(Helpers.replaceUnderscore(s)) }}</option>
              }
            }
          </select>
        </div>

        <button class="secondary-button" [disabled]="changeStatusForm.invalid" type="submit">
          @if (isEditing()) {
            <app-loading-indicator></app-loading-indicator>
          } @else {
            Change status
          }
        </button>

      </div>
    </form>
  </section>
}






